import { render, staticRenderFns } from "./exibir-beneficio.vue?vue&type=template&id=38463531&"
import script from "./exibir-beneficio.vue?vue&type=script&lang=ts&"
export * from "./exibir-beneficio.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins-hml/workspace/pracessivel-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('38463531')) {
      api.createRecord('38463531', component.options)
    } else {
      api.reload('38463531', component.options)
    }
    module.hot.accept("./exibir-beneficio.vue?vue&type=template&id=38463531&", function () {
      api.rerender('38463531', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/beneficio/exibir-beneficio.vue"
export default component.exports